var slider_chevron_right = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
	<path style="fill:currentColor" d="M388.819,239.537L156.092,6.816c-9.087-9.089-23.824-9.089-32.912,0.002
	c-9.087,9.089-9.087,23.824,0.002,32.912l216.27,216.266L123.179,472.272c-9.087,9.089-9.087,23.824,0.002,32.912
	c4.543,4.544,10.499,6.816,16.455,6.816c5.956,0,11.913-2.271,16.457-6.817L388.819,272.45c4.366-4.364,6.817-10.283,6.817-16.455
	C395.636,249.822,393.185,243.902,388.819,239.537z"/>
</svg>`;
var slider_chevron_left = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
	<path style="fill:currentColor" d="M172.548,256.005L388.82,39.729c9.089-9.089,9.089-23.824,0-32.912s-23.824-9.089-32.912,0.002
	L123.18,239.551c-4.366,4.363-6.817,10.282-6.817,16.454c0,6.173,2.453,12.093,6.817,16.457l232.727,232.721
	c4.543,4.544,10.499,6.816,16.455,6.816s11.913-2.271,16.457-6.817c9.089-9.089,9.089-23.824,0-32.912L172.548,256.005z"/>
</svg>`;

if ($("#related-slider").length) var $slider61 = $("#related-slider").on("init", function(e) {
    $("#related-slider").fadeIn(1e3)
}).slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<button type="button" class="slick-prev">Previous' + slider_chevron_left + '</button>',
    nextArrow: '<button type="button" class="slick-next">Next' + slider_chevron_right + '</button>',
    responsive: [{
        breakpoint: 500,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }]
});

if ($(".more-starp-sl").length) var $slider6 = $(".more-starp-sl").on("init", function(e) {
    $(".more-starp-sl").fadeIn(1e3)
}).slick({
    infinite: !0,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    lazyLoad: "ondemand",
    responsive: [{
        breakpoint: 992,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 580,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }, {
        breakpoint: 480,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }]
});
if ($(".product__slider-main").length) {

    var $slider = $(".product__slider-main").on("init", function(e) {
            $(".product__slider-main").fadeIn(1e3)
        }).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !0,
            autoplay: !1,
            lazyLoad: "ondemand",
            autoplaySpeed: 3e3,
            asNavFor: ".product__slider-thmb"
        }),
        $slider2 = $(".product__slider-thmb").on("init", function(e) {
            $(".product__slider-thmb").fadeIn(1e3)
        }).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            margin: 10,
            lazyLoad: "ondemand",
            asNavFor: ".product__slider-main",
            dots: !1,
            centerMode: !0,
            focusOnSelect: !0,
            prevArrow: '<button type="button" class="slick-prev">Previous' + slider_chevron_left + '</button>',
            nextArrow: '<button type="button" class="slick-next">Next' + slider_chevron_right + '</button>'
        });

    $(".product__slider-thmb .slick-slide").removeClass("slick-active"), $(".product__slider-thmb .slick-slide").eq(0).addClass("slick-active"), $(".product__slider-main").on("beforeChange", function(e, i, s, l) {
            var o = l;
            $(".product__slider-thmb .slick-slide").removeClass("slick-active"), $(".product__slider-thmb .slick-slide").eq(o).addClass("slick-active")
        }),
        $(["js-sliderWithProgressbar"], function(e) {
            $(".product__slider-main").each(function() {
                me.slider = new e($(this), options, sliderOptions, previewSliderOptions)
            })
        });
    var options = {
            progressbarSelector: ".bJS_progressbar",
            slideSelector: ".bJS_slider",
            previewSlideSelector: ".bJS_previewSlider",
            progressInterval: "",
            onCustomProgressbar: function(e, i) {}
        },
        sliderOptions = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !1,
            fade: !0,
            autoplay: !1
        },
        previewSliderOptions = {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: !1,
            focusOnSelect: !0,
            centerMode: !0,
            autoplay: !1
        }
}
function init_featured_items_sliders() {
	$('.cfi-slider').each(function(){
		if(window.matchMedia("(min-width: 767px)").matches) {
			if(!$(this).hasClass('slick-initialized')) {
				slidesToShowDesktop = parseInt($(this).data('slides-to-show-desktop')) + 0.5;
				$(this).slick({
					slidesToShow: slidesToShowDesktop,
					slidesToScroll: 1,
					dots: false,
					arrows: false,
					infinite: false,
					adaptiveHeight: false,
					autoplay: false,
					swipeToSlide: true
				});
			}
		} else {
			if ($(this).hasClass('slick-initialized')) {
                $(this).slick('unslick');
            }
		}
	});
}

if($('.cfi-slider').length) {
	init_featured_items_sliders();
	$(window).on('resize', init_featured_items_sliders);
}

$('.afp-items-wrapper.init-slider').slick({
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: false,
    swipeToSlide: true,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
    ]
});

$(document).on('shopify:section:load', function(event) {
  if($(event.target).hasClass('custom-featured-items')) {
    init_featured_items_sliders();
  }
});
